export const enum ECtaButtonTypes {
  BUY_ONLINE_BUTTON_REGULAR = 'BUY_ONLINE_BUTTON_REGULAR',
  BUY_ONLINE_BUTTON_APC = 'BUY_ONLINE_BUTTON_APC',
  DOWNLOAD_BUTTON = 'DOWNLOAD_BUTTON',
  NOTIFY_ME_BUTTON = 'NOTIFY_ME_BUTTON',
  ADD_TO_CART_BUTTON = 'ADD_TO_CART_BUTTON',
  PROMOTED_BUTTON = 'PROMOTED_BUTTON',
  PRODUCT_SELECTOR_BUTTON = 'PRODUCT_SELECTOR_BUTTON',
}

export const PRIMARY_BUTTONS = [
  // order matters
  ECtaButtonTypes.NOTIFY_ME_BUTTON,
  ECtaButtonTypes.DOWNLOAD_BUTTON,
  ECtaButtonTypes.PRODUCT_SELECTOR_BUTTON,
  ECtaButtonTypes.BUY_ONLINE_BUTTON_REGULAR,
  ECtaButtonTypes.BUY_ONLINE_BUTTON_APC,
];

export const SECONDARY_BUTTONS = [ ECtaButtonTypes.ADD_TO_CART_BUTTON ];

export const APC_PRIMARY_BUTTONS = [
  // order matters
  ECtaButtonTypes.NOTIFY_ME_BUTTON,
  ECtaButtonTypes.DOWNLOAD_BUTTON,
  ECtaButtonTypes.PRODUCT_SELECTOR_BUTTON,
  ECtaButtonTypes.BUY_ONLINE_BUTTON_REGULAR,
];
